import { style, styleVariants } from '@vanilla-extract/css';
import { spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { themeVars } from '@tundr/theme';
import { ModalSkeletonSize } from './ModalSkeleton.types';

const SMALL_MAX_WIDTH_PX = 600;

const modalSkeletonContainerBaseClass = style({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
  gap: spacingVars.xl,
  padding: `0 ${spacingVars.xl}`,
});

export const modalSkeletonContainerClass = styleVariants({
  [ModalSkeletonSize.FULL]: [
    modalSkeletonContainerBaseClass,
    {
      width: '100%',
    },
  ],
  [ModalSkeletonSize.SMALL]: [
    modalSkeletonContainerBaseClass,
    {
      width: '100%',
      maxWidth: SMALL_MAX_WIDTH_PX,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  ],
});

export const modalContentClass = style({
  width: '100%',
  flex: 1,
  fontSize: themeVars.font.size.textLg,
});
